import _ from "lodash"

export const getItinerary = ({ itinerary }) => itinerary

export const getVisitsByItinerary = (state) => {
  let visits = getVisits(state)

  const selectedItinerary = getSelectedItinerary(state)
  const selectedSeason = getSelectedSeason(state)

  if (selectedSeason) {
    const { startDate, endDate } = selectedSeason
    visits = visits.filter((v) => startDate <= v.date && v.date <= endDate)
  }

  if (selectedItinerary) {
    const itineraryId = selectedItinerary.id
    visits = visits.filter((v) => v.itinerary.id === itineraryId)
  }

  return visits
}

export const getVisitsByPort = (state) => {
  let visits = getVisits(state)

  const selectedPort = getSelectedPort(state)
  const selectedSeason = getSelectedSeason(state)

  if (selectedSeason) {
    const { startDate, endDate } = selectedSeason
    visits = visits.filter((v) => startDate <= v.date && v.date <= endDate)
  }
  if (selectedPort) {
    const portId = selectedPort.id
    visits = visits.filter((v) => v.port.id === portId)
  }

  return visits
}

export const getVisitsByShip = (state) => {
  let visits = getVisits(state)

  const selectedShip = getSelectedShip(state)
  const selectedSeason = getSelectedSeason(state)

  if (selectedSeason) {
    const { startDate, endDate } = selectedSeason
    visits = visits.filter((v) => startDate <= v.date && v.date <= endDate)
  }

  if (selectedShip) {
    const shipId = selectedShip.id
    visits = visits.filter((v) => v.ship.id === shipId)
  }

  return visits
}

export const getSeasons = (state) => getItinerary(state).seasons

export const getItineraries = (state) => getItinerary(state).itineraries

export const getPorts = (state) => getItinerary(state).ports

export const getShips = (state) => getItinerary(state).ships

export const getVisits = (state) => getItinerary(state).visits

export const getSelectedSeason = (state) => {
  const { selectedSeasonId } = getItinerary(state)

  return _.find(getSeasons(state), (season) => season.id === selectedSeasonId)
}

export const getSelectedItinerary = (state) => {
  const { selectedItineraryId } = getItinerary(state)

  return _.find(getItineraries(state), (itinerary) => itinerary.id === selectedItineraryId)
}

export const getSelectedPort = (state) => {
  const { selectedPortId } = getItinerary(state)

  return _.find(getPorts(state), (port) => port.id === selectedPortId)
}

export const getSelectedShip = (state) => {
  const { selectedShipId } = getItinerary(state)

  return _.find(getShips(state), (ship) => ship.id === selectedShipId)
}
